import { SINGLE_SELECT_OPTION_SELECTOR } from "./constants";

const syncOptionStates = (
  selectElement: HTMLSelectElement,
  dropdownMenu: HTMLDivElement
) => {
  const optionButtons = dropdownMenu.querySelectorAll<HTMLButtonElement>(
    SINGLE_SELECT_OPTION_SELECTOR
  );

  optionButtons.forEach((optionButton) => {
    const optionIsSelected =
      optionButton.dataset.optionValue === selectElement.value;

    optionButton.setAttribute("aria-selected", `${optionIsSelected}`);
    optionButton.classList.toggle("bg-primary-50", optionIsSelected);
    optionButton.classList.toggle("font-medium", optionIsSelected);
  });
};

export default syncOptionStates;
